/**
 * Created by tendlich
 * the layout of the list view
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/ticketTab/extendedList/ticketListLayout.tmpl"),
        SearchFilterLayout = require("connection-views/ticketTab/widgets/SearchFilterView"),
        Paging = require("ui/paging/Paging"),
        DropdownMenu = require("ui/dropdown-menu/DropdownMenu"),
        InputSearch = require("ui/input-search/InputSearch"),
        Loader = require("ui/loader/Loader"),
        TicketsListLayout = {};

    var ACTION_MENU_ITEMS = {
        ADD: "add",
        EXPORT: "exportAll"
    };

    var isFilterActiveOrOpen = false;

    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {

        TicketsListLayout = Marionette.Layout.extend({
            className: "ticket-list",
            template: template,
            isPermanent: true,
            regions: {
                header: ".page-header",
                gridRegion: ".tickets-grid-container"
            },
            ui: {
                actionMenuContainer: ".action-menu",
                pagingContainer: ".ticket-list-paging-container",
                searchContainer: ".search-container",
                filterButtonContainer: ".filter-button-container",
                filterButton: ".filter-button",
                filterContainer: ".filter-wrapper"
            },
            uiComponents: {
                paging: {
                    type: Paging,
                    options: {
                        el: "view.ui.pagingContainer",
                        collection: "view.collection",
                        blockWrongPageNumber: true,
                        pageType: Paging.PAGE_TYPE.PAGE
                    },
                    events: {
                        "change:page": "_onPagingChange"
                    }
                },
                actionMenu: {
                    type: DropdownMenu,
                    options: {
                        el: "view.ui.actionMenuContainer",
                        name: LE.translator.translate("LEFramework.global.captions.action"),
                        collection: "view._getActionMenuCollection"
                    },
                    events: {
                        "change": "_onActionMenuSelected"
                    }
                },
                search: {
                    type: InputSearch,
                    options: {
                        el: "view.ui.searchContainer",
                        permutation: InputSearch.Permutation.A,
                        placeholder: LE.translator.translate("LEConnection.cases.ticketTab.actionSearch.placeholder")
                    },
                    events: {
                        enterPressed: "_onSearchString",
                        onClickIcon: "_onSearchString",
                        onKeyUp: "_onSearchString",
                        onblur: "_onSearchBlur"
                    }
                },
                filter: {
                    type: SearchFilterLayout,
                    options: {
                        collection: "view._getCollection",
                        el: "view.ui.filterContainer",
                        triggerElement: "view.ui.filterButtonContainer",
                        closeOnClickOutside: true,
                        hidden: true
                    }
                }
            },
            events: {
                "click @ui.filterButtonContainer": "_openFilter"
            },
            initialize: function (options) {
                this.collection = options.collection;
                this.context = options.context;
                this.actionMenuVisibility = options.actionMenuVisibility || {};
                this.collection.on("sync", this.onRender, this);
            },

            _bindEvents: function () {
                this.listenTo(this.context, "change:searchTerm", this._onSearchTermChanged);
                this.listenTo(this.uiComponents.filter, "filter:active", this._filterActive);
                this.listenTo(this.uiComponents.filter, "filter:passive", this._filterPassive);
                this.listenTo(this.uiComponents.filter, "filter:closed", this._filterClosed);
            },

            //triggered as soon as the extended view is rendered
            onRender: function () {
                if (isFilterActiveOrOpen) {
                    this._filterActive();
                }
                this._setCurrentPagingInfo();
                this._setActionMenu();
                this._setSearchInputValue(this._getSearchTerm());
                this._bindEvents();
            },

            _setActionMenu: function () {
                if (this.collection.length === 0) {
                    this._onActionMenuSet({id: TicketsListLayout.ACTION_MENU_ITEMS.EXPORT, enabled: false});
                } else {
                    this._onActionMenuSet({id: TicketsListLayout.ACTION_MENU_ITEMS.EXPORT, enabled: true});
                }
            },

            _getCollection: function () {
                return this.collection;
            },

            //----ACTION MENU
            _getActionMenuCollection: function () {
                var itemsArr = _.map(ACTION_MENU_ITEMS, function (itemId) {
                    return {
                        id: itemId,
                        actionName: LE.translator.translate("LEFramework.global.captions." + itemId),
                        align: "right",
                        title: LE.translator.translate("LEFramework.global.captions." + itemId + ".tooltip")
                    };
                });
                itemsArr = _.filter(itemsArr, function (item) {
                    return this.actionMenuVisibility[item.id];
                }, this);
                this.actionsCollection = new DropdownMenu.Collection(itemsArr);
                return this.actionsCollection;
            },

            _onActionMenuSet: function (options) {
                var actionItemModel = this.actionsCollection.get(options.id);
                if (!_.isEmpty(actionItemModel)) {
                    actionItemModel.set("enabled", options.enabled);
                }
            },

            _onActionMenuSelected: function (componentId, eventName, selectedItemId) {
                this.trigger("TicketListLayout::actionMenu:select", selectedItemId);
            },

            //----LOADER
            setLoader: function () {
                this._getLoader().render();
            },

            closeLoader: function () {
                this._getLoader().close();

            },

            _getLoader: function () {
                if (!this.loader) {
                    this.loader = new Loader({
                        permutation: Loader.PERMUTATION.L,
                        el: this.regions.gridRegion,
                        zIndex: 2
                    });
                }
                return this.loader;
            },

            //-----PAGING
            _onPagingChange: function (componentId, eventName, currentPageNumber) {
                this.trigger("TLL::paging:change", currentPageNumber);
            },
            updatePagingInfo: function () {
                this._setCurrentPagingInfo();
            },
            //determines the collection paging info
            _setCurrentPagingInfo: function () {
                var currentPagingInfo = this.collection.getPagerInfo();
                if (_.isFunction(this.uiComponents.paging.setInfo)) {
                    this.uiComponents.paging.setInfo(currentPagingInfo.currentPageNumber, currentPagingInfo.totalPages);
                }
            },
            _triggerUsageTracking: function (searchValue) {
                this.trigger("usage::track:search", searchValue);
            },
            _triggerSearch: function (searchValue) {
                this.trigger("search:initiate", searchValue);
                this._setSearchTerm((searchValue) ? searchValue.value : "");
            },
            _onSearchString: function (componentId, eventName, searchValue) {
                this._triggerSearch(searchValue);
            },

            _onSearchBlur: function (componentId, eventName, searchValue) {
                //this._triggerSearch(searchValue);
                //this._triggerUsageTracking(searchValue);
            },
            //-----FILTER
            _openFilter: function () {
                this.uiComponents.filter._show();
                this.ui.filterButton.addClass("is-opened");
            },

            _filterActive: function () {
                this.ui.filterButton.addClass("is-active");
                isFilterActiveOrOpen = true;
            },

            _filterPassive: function () {
                this.ui.filterButton.removeClass("is-active");
                isFilterActiveOrOpen = false;
            },

            _filterClosed: function () {
                this.ui.filterButton.removeClass("is-opened");
            },

            _setSearchTerm: function (value) {
                this.context.set("searchTerm", value);
            },

            _getSearchTerm: function () {
                var searchTerm = this.context.get("searchTerm");
                return (searchTerm && searchTerm.length > 0) ? searchTerm : "";
            },

            _onSearchTermChanged: function () {
                this._setSearchInputValue(this._getSearchTerm());
            },

            _setSearchInputValue: function (value) {
                this.uiComponents.search.setValue(value);
            }

        });

    });
    TicketsListLayout.ACTION_MENU_ITEMS = ACTION_MENU_ITEMS;
    return TicketsListLayout;
});
